import { PauseOutlined } from '@mui/icons-material'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PauseModal } from '../../pause-modal'

interface Props {
  requestId: string
  onClose?: () => void
}

export const PauseMenuItem = ({ requestId, onClose }: Props) => {
  const { t } = useTranslation('requests')
  const [pauseModalOpen, setPauseModalOpen] = useState(false)

  const handleModalOpen = () => {
    setPauseModalOpen(true)
    onClose?.()
  }
  const handleModalClose = () => setPauseModalOpen(false)

  return (
    <>
      <MenuItem onClick={handleModalOpen}>
        <ListItemIcon>
          <PauseOutlined />
        </ListItemIcon>
        <ListItemText> {t('manage-request.pause')}</ListItemText>
      </MenuItem>
      <PauseModal open={pauseModalOpen} requestId={requestId} closeModal={handleModalClose} />
    </>
  )
}
